(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory5sService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory5s: function (parms) {
                return $ihttp.post({
                    method: 2686,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
